import { render, staticRenderFns } from "./EduDetails.vue?vue&type=template&id=110f7b11&scoped=true"
import script from "./EduDetails.vue?vue&type=script&lang=js"
export * from "./EduDetails.vue?vue&type=script&lang=js"
import style0 from "./EduDetails.vue?vue&type=style&index=0&id=110f7b11&prod&scoped=true&lang=css"
import style1 from "./EduDetails.vue?vue&type=style&index=1&id=110f7b11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f7b11",
  null
  
)

export default component.exports